import { faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo } from 'react';

import { Color } from '@/constants/color';
import DualTime from '@/ui/components/DualTime';
import Modal from '@/ui/components/Modal';

import { Props } from './types';

const ModalIcon = () => (
  <FontAwesomeIcon className="h-6 w-6 text-yellow-600" aria-hidden="true" icon={faClock} />
);

const DrugScreenWarningModal = ({
  appointmentStartAt,
  isAppointmentInTheFuture,
  isModalOpen,
  personTimeZone,
  goToDrugScreenForm,
  onClose
}: Props) => (
  <Modal
    dismissButton={{
      children: 'Cancel',
      color: Color.WHITE
    }}
    button={{
      onClick: goToDrugScreenForm,
      color: Color.BLUE,
      size: 'sm',
      children: 'Record Drug Screen'
    }}
    icon={<ModalIcon />}
    iconBackgroundColor="bg-yellow-100"
    open={isModalOpen}
    onClose={onClose}
    textContent="Are you sure you wish to enter results for it?"
    title={
      <>
        <p className="font-bold">
          {`This appointment ${isAppointmentInTheFuture ? 'will take place' : 'took place'} on`}{' '}
          <DualTime memberTZ={personTimeZone} dateTime={appointmentStartAt}></DualTime>
        </p>
        <p className="font-bold mt-2 text-gray-500 text-sm">
          Please check that this is the correct appointment.
        </p>
      </>
    }
  />
);

export default memo(DrugScreenWarningModal);
